<template>
  <div class="myTableBox">
    <div class="table-column">
      <div class="table-column-header" :style="{ backgroundColor: headerBg }">
        <div
          v-for="(item, index) in tableColumn"
          :key="index"
          class="padding20 minWidth150"
          :style="{ width: item.width + 'px' } || {}"
          v-bind="item.bind || {}"
        >
          <span v-if="!item.html">{{ item.label }}</span>
          <span v-else v-html="item.html()"></span>
        </div>
      </div>
      <div class="listSty" v-if="tableBody.length > 0">
        <div v-for="(item, index) in tableBody" :key="index" class="borderSty">
          <div class="table-body">
            <div
              class="minWidth150"
              :style="{ width: con.column.width + 'px' } || {}"
              v-for="(con, conIndex) in item.child"
              :key="conIndex"
              v-bind="{ ...con.column.bind } || {}"
              :class="con.column.classBar"
            >
              <div v-if="!item.html">
                {{
                  con.column.formatter
                    ? con.column.formatter({ [con.column.prop]: con.con })
                    : con.con
                }}
                <!-- <div v-if="con.row.uname">{{ con.row.uname || "1233" }}</div> -->
              </div>
              <div v-else v-html="item.html()"></div>
              <van-icon
                @click="downDetail(con, index)"
                v-if="con.column.isSelect"
                :name="item.isDetail ? 'arrow-up' : 'arrow-down'"
                v-bind="con.column.iconStyle || {}"
              />
              <div v-if="con.column.operation">
                <slot :currentRow="con.row" name="slot"></slot>
              </div>
              <div v-if="con.column.nameOp">
                <slot :currentRow="con.row" name="nameOp"></slot>
              </div>
            </div>
          </div>
          <div v-if="item.isDetail" class="detail">
            <div
              class="felxSty"
              v-for="(val, index) in item.detailInfo[0].line"
              :key="index"
            >
              <div>
                {{ val.level_name
                }}{{
                  val.state === 2
                    ? "闯关失败"
                    : val.state === 4
                    ? "结束闯关"
                    : "闯关成功"
                }}
              </div>
              <div class="iconSty">
                <img
                  src="@/assets/images/squirrelCup/2024/cupTwo/jiangbei.png"
                  alt=""
                />
                <span>{{ val.score }}</span>
              </div>
              <div class="iconSty">
                <img
                  src="@/assets/images/squirrelCup/2024/cupTwo/jinbi.png"
                  alt=""
                />
                <span>{{ val.coin }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Empty :word="''" v-else></Empty>
    </div>
  </div>
</template>

<script>
import { Icon, List, Cell } from "vant";
import Empty from "./Empty.vue";

export default {
  name: "MyTable",
  components: {
    "van-icon": Icon,
    [List.name]: List,
    [Cell.name]: Cell,
    Empty,
  },
  props: {
    headerBg: {
      type: String,
      default: "red",
    },
    tableColumn: {
      type: Array,
      default: () => [
        {
          label: "日期",
          prop: "date",
          bind: {
            style: {
              colpr: "red",
              minWidth: "200px",
            },
          },
          formatter: (row) => {
            // console.log("row", row);
            return row.date ? "1" : "2";
          },
          html: (row) => {
            console.log("row", row);
            return `<div>${row.date}</div>`;
          },
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "年龄",
          prop: "age",
          isSelect: true,
          iconStyle: {
            color: "red",
          },
        },
      ],
    },
    tableData: {
      type: Array,
      default: () => [
        {
          date: "1",
          name: "3",
          age: 5,
        },
        {
          date: "2",
          name: "4",
          age: 6,
        },
      ],
    },
  },
  data() {
    return {
      tableBody: [],
    };
  },
  computed: {},
  mounted() {
    // this.setTableBody();
  },
  watch: {
    tableData: function (oldVal, newVal) {
      this.setTableBody();
    },
  },
  methods: {
    setTableBody() {
      const keys = this.tableColumn.map((item) => item.prop);
      const tableBody = this.tableData.map((item) => {
        const arr_con = [];
        const rows = [];
        // console.log(item, "item");
        keys.forEach((key) => {
          // console.log("key", key);
          arr_con.push({
            con: item[key],
            row: { ...item },
            column:
              this.tableColumn.filter((column) => column.prop === key)[0] || {},
          });
        });
        rows.push({
          line: item.finish_list,
        });
        return {
          child: arr_con,
          detailInfo: rows,
          isDetail: false,
        };
      });

      this.$set(this, "tableBody", tableBody);
    },
    downDetail(currentItem, bodyIndex) {
      const tableBody = this.tableBody;
      tableBody[bodyIndex].isDetail = !tableBody[bodyIndex].isDetail;
      this.$set(this, "tableBody", tableBody);
      // console.log(
      //   "当前的prop",
      //   currentItem.column.prop,
      //   "当前行内容",
      //   this.tableData[bodyIndex]
      // );
    },
  },
};
</script>

<style scoped lang="less">
.myTableBox {
  display: flex;
  font-size: 32px;
  flex-direction: row;
  min-width: 100vw;
  overflow: hidden;
  overflow-x: scroll;
  text-align: center;
  color: #4f4f4f;
  .table-column {
    min-width: 100vw;
    // border: 1px solid #000;
    border-left: none;
    border-right: none;
    padding: 0 10px;
    .table-column-header {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
    .borderSty {
      border-bottom: 2px solid rgb(216, 235, 252);
    }
    .table-body {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      color: #4F4F4F;
      // height: 168px;
      padding: 20px 0;
      // line-height: 168px;
    }
  }
  .padding20 {
    padding: 20px;
  }
  .minWidth150 {
    min-width: 136px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 28px;
  }
  .detail {
    background: #f6f9fd;
    border-radius: 16px;
    margin: 0 24px;
    margin-bottom: 42px;
  }
  .slotSty {
    display: flex;
    flex-direction: column;
  }

  .felxSty {
    display: flex;
    justify-content: space-between;
    padding: 24px 64px;
    img {
      width: 32px;
      height: 32px;
    }
  }
  .iconSty {
    display: flex;
    align-items: center;
    width: 120px;
    span {
      margin-left: 10px;
    }
  }
  .fontSty :first-child {
    flex: 1;
    text-align: right;
  }
}
</style>
